import React from 'react';

interface ToggleProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label?: string;
    disabled?: boolean;
    size?: 'smaller' | 'small' | 'medium' | 'large';
}

const SIZE_MAP = {
    smaller: { width: 28, height: 14, knob: 10, font: 12 },
    small:   { width: 34, height: 16, knob: 12, font: 16 },
    medium:  { width: 40, height: 20, knob: 16, font: 22 },
    large:   { width: 52, height: 26, knob: 20, font: 28 },
};

const Toggle: React.FC<ToggleProps> = ({ checked, onChange, label, disabled, size = 'medium' }) => {
    const dims = SIZE_MAP[size] || SIZE_MAP['medium'];
    return (
        <label
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                cursor: disabled ? 'not-allowed' : 'pointer',
                gap: 12,
                fontSize: dims.font,
                fontWeight: 400,
                color: 'var(--color-default-text)',
                userSelect: 'none',
                opacity: disabled ? 0.5 : 1,
            }}
        >
        <span
            style={{
                width: dims.width,
                minWidth: dims.width,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <span
                style={{
                    width: dims.width,
                    height: dims.height,
                    borderRadius: 24,
                    background: checked ? 'var(--color-primary)' : '#00000025',
                    position: 'relative',
                    transition: 'background 0.2s',
                    display: 'inline-block',
                }}
            >
            <span
                style={{
                    position: 'absolute',
                    left: checked ? dims.width - dims.knob - 2 : 2,
                    top: (dims.height - dims.knob) / 2,
                    width: dims.knob,
                    height: dims.knob,
                    borderRadius: '50%',
                    background: 'var(--color-page-background)',
                    boxShadow: '0 1px 4px #e5e7eb',
                    transition: 'left 0.2s',
                }}
            />
            <input
                type="checkbox"
                    checked={checked}
                    disabled={disabled}
                    onChange={e => onChange(e.target.checked)}
                    style={{
                    opacity: 0,
                    width: dims.width,
                    height: dims.height + 4,
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    margin: 0,
                    cursor: disabled ? 'not-allowed' : 'pointer',
                }}
            />
            </span>
        </span>
        {label && <span style={{ fontSize: 14, color: 'var(--color-default-text)', fontWeight: 400 }}>{label}</span>}
        </label>
    );
};

export default Toggle;
